export const transformEmptyToUndefined = (
  currentValue: any,
  originalValue: any,
) => (!originalValue || originalValue?.length === 0 ? undefined : currentValue);
export const transformEmptyToNull = (currentValue: any, originalValue: any) =>
  !originalValue || originalValue?.length === 0 ? null : currentValue;
